import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { navMeta } from '../../layouts/navData';
import { backlogDashboardId } from './backlogDashboard';
import { DashboardDesignerFrame, type DashboardFrameMode } from './DashboardDesignerFrame';

// ─────────────────────────────────────────────────────────────────────────────
// Standalone full-page dashboard FRAME — opened in a NEW TAB by "Show Dashboard in
// a separate tab" (user request 2026-10-05: the separate tab was the bare DevExpress
// viewer with NO Design / View / Back buttons). This renders the SAME
// DashboardDesignerFrame the in-place view uses, so the new tab carries that toolbar.
// No app shell (sidebar/header) — just the dashboard + its toolbar. Back closes the
// tab (it was script-opened via window.open). Route: /dashboard-frame/:navId.
// ─────────────────────────────────────────────────────────────────────────────

export default function DashboardFramePage() {
  const { navId } = useParams<{ navId: string }>();
  const dashboardId = navId ? backlogDashboardId(navId) : null;
  // Opens in VIEW (read-only); an admin can flip to Design with the toolbar toggle.
  const [mode, setMode] = useState<DashboardFrameMode>('view');
  const title = navId ? (navMeta(navId)?.label ?? 'Dashboard') : 'Dashboard';

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: '#fff' }}>
      <DashboardDesignerFrame
        dashboardId={dashboardId}
        title={title}
        mode={mode}
        onModeChange={setMode}
        onBack={() => window.close()}
      />
    </div>
  );
}
